<button
  (click)="onClick(id)"
  [class.disabled]="disabled"
  [class]="class ? class : ''"
  [disabled]="disabled"
  [id]="id"
  [type]="type"
>
  <div
    [ngClass]="{
      'position-relative spinning': spinner && buttonId && buttonId == id,
    }"
  >
    @if (iconClass) {
      <i class="{{ iconClass }}"></i>
    }
    <ng-content></ng-content>
  </div>
</button>
